import React, { createContext, useEffect, useState } from "react";

export const FilterContext = createContext();

const fetchConfig = async () => {
  try {
    const response = await fetch('/config.json');
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Erro ao buscar o config:", error);
    return null;
  }
};
const config = await fetchConfig();

// Função para buscar os produtos
const fetchProducts = async () => {
  try {
    const response = await fetch(`${config.url}/catalogo/${config.diretorio}/produtos.json?v=${crypto.randomUUID()}`);
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Erro ao buscar os produtos:", error);
    return [];
  }
};

// Estado inicial do filtro
const initialFilter = {
  colors: [],
  prices: { min: 0, max: 1000 },
  categories: [],
  embroideryformats: [],
  name: "",
};

// Função para embaralhar o array
const shuffleArray = (array) => {
  const shuffledArray = [...array];
  for (let i = shuffledArray.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [shuffledArray[i], shuffledArray[j]] = [shuffledArray[j], shuffledArray[i]];
  }
  return shuffledArray;
};

const FilterContextProvider = ({ children }) => {
  const [filter, setFilter] = useState(initialFilter);
  const [filteredProducts, setFilteredProducts] = useState([]);
  const [allProducts, setAllProducts] = useState([]); // Para armazenar todos os produtos

  const misturarProdutos = true;

  // Buscar os produtos ao montar o componente
  useEffect(() => {
    const getProducts = async () => {
      const products = await fetchProducts(); // Fetch dos produtos
      const shuffledProducts = misturarProdutos ? shuffleArray(products) : products;
      setAllProducts(shuffledProducts); // Armazena os produtos embaralhados ou normais
      setFilteredProducts(shuffledProducts); // Inicializa o estado dos produtos filtrados
    };
    getProducts();
  }, [misturarProdutos]);

  const saveFilter = (newFilter) => {
    setFilter((currVal) => ({ ...newFilter, name: currVal.name }));
  };

  const saveInputSearchVal = (name) => {
    setFilter((currVal) => ({ ...currVal, name }));
  };

  const deleteInputSearchVal = () => {
    setFilter((currVal) => ({ ...currVal, name: "" }));
  };

  const deleteFilter = (valToDelete, filterName) => {
    setFilter((currVal) => {
      const newArray = currVal[filterName].filter((val) => val !== valToDelete);
      return { ...currVal, [filterName]: [...newArray] };
    });
  };

  const deleteColor = (colorToDelete) => {
    deleteFilter(colorToDelete, "colors");
  };

  const deleteCategory = (categoryToDelete) => {
    deleteFilter(categoryToDelete, "categories");
  };

  const deleteEmbroideryFormat = (embroideryformatToDelete) => {
    deleteFilter(embroideryformatToDelete, "embroideryformats");
  };

  // Filtragem
  useEffect(() => {
    let newFilter = [...allProducts];

    // Filtrar por cor
    newFilter = newFilter.filter((prod) => {
      if (filter.colors.length === 0) return true;
      return filter.colors.indexOf(prod.color) >= 0;
    });

    // Filtrar por categoria
    newFilter = newFilter.filter((prod) => {
      if (filter.categories.length === 0) return true;
      return filter.categories.indexOf(prod.category) >= 0;
    });

    // Filtrar por nome
    newFilter = newFilter.filter((prod) => {
      const prodNames = prod.name.split(" ");
      const productNameHasSearchValue = prodNames.some((name) => {
        return name.toLowerCase().startsWith(filter.name);
      });
      return productNameHasSearchValue;
    });

    // Filtrar por preço
    newFilter = newFilter.filter((prod) => {
      return (
        prod.price >= +filter.prices?.min && prod.price <= +filter.prices?.max
      );
    });

    setFilteredProducts(newFilter);
  }, [
    filter.categories,
    filter.colors,
    filter.prices.max,
    filter.prices.min,
    filter,
    allProducts, // Adicionei para garantir que o filtro seja atualizado ao carregar os produtos
  ]);

  return (
    <FilterContext.Provider
      value={{
        saveFilter,
        saveInputSearchVal,
        deleteInputSearchVal,
        deleteColor,
        deleteCategory,
        deleteEmbroideryFormat,
        filteredProducts,
        initialFilter,
        filter,
      }}
    >
      {children}
    </FilterContext.Provider>
  );
};

export default FilterContextProvider;
